import { render, staticRenderFns } from "./Reauthorization.vue?vue&type=template&id=66db44c0&scoped=true"
import script from "./Reauthorization.vue?vue&type=script&lang=ts"
export * from "./Reauthorization.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66db44c0",
  null
  
)

export default component.exports